import type { ChatVinculoTipo } from "@/shared/hooks/useChatOperacional";

export function labelChatVinculo(tipo: ChatVinculoTipo): string {
  switch (tipo) {
    case "judicial":
      return "Judicial";
    case "administrativo":
      return "Adm.";
    case "extrajudicial":
      return "Extrajudicial";
    case "procedimento":
      return "Procedimento";
    case "atendimento_avulso":
      return "Atend. avulso";
    default:
      return "Livre";
  }
}

export function corBadgeChatVinculo(tipo: ChatVinculoTipo): { bg: string; text: string; border: string } {
  switch (tipo) {
    case "judicial":
      return { bg: "bg-[#791614]/10", text: "text-[#791614]", border: "border-[#791614]/20" };
    case "administrativo":
      return { bg: "bg-[#d7b369]/15", text: "text-[#5c4a22]", border: "border-[#d7b369]/35" };
    case "extrajudicial":
      return { bg: "bg-blue-500/10", text: "text-blue-700", border: "border-blue-500/25" };
    case "procedimento":
      return { bg: "bg-purple-500/10", text: "text-purple-700", border: "border-purple-500/25" };
    case "atendimento_avulso":
      return { bg: "bg-emerald-500/10", text: "text-emerald-800", border: "border-emerald-500/30" };
    default:
      return { bg: "bg-[#f9f6f0]", text: "text-[#555]", border: "border-[#a9abae]/30" };
  }
}
